// src/app/interceptors/frontend-route.interceptor.ts
import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent
} from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class FrontendRouteInterceptor implements HttpInterceptor {
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const currentUrl = window.location.href;
    const cloned = req.clone({
      setHeaders: {
        'X-Frontend-Route': currentUrl
      }
    });
    return next.handle(cloned);
  }
}
